const state = () => ({
    user: {
        email: '',
        first_name: '',
        last_name: '',
        contact_number: '',
    },
    application_type: {}, // 'existing_user', 'new_user', 'guest_user'
    apply_uuid: '',
    is_applied: false,
    apply_step: 1,
    apply_steps_count: 2,
    is_apply_form_open: false,
    make_resume_default: true,
    is_apply_complete: false,
});

export default state;
